import PlatformSignUpFormWrapper from "@/features/sign-up/components/platform-sign-up-form-wrapper";
import SignUpForm from "@/features/sign-up/components/sign-up-form";
import { features } from "@blueskydataplatform/shared-ui/config/features";

const RegisterRoute = () => {
  const { platformSubscriptionsEnabled } = features;
  return platformSubscriptionsEnabled ? <PlatformSignUpFormWrapper /> : <SignUpForm />;
};

export default RegisterRoute;
